import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { SearchDrawerComponent } from '../../search/search-drawer/search-drawer.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { TranslateService } from '@ngx-translate/core';
import { SettingDrawerComponent } from '../../menu-drawer/setting-drawer/setting-drawer.component';
@Component({
  selector: 'app-navbar-right',
  templateUrl: './navbar-right.component.html',
  styleUrls: ['./navbar-right.component.scss']
})
export class NavbarRightComponent implements OnInit {
  @Output() changeShowNav = new EventEmitter();
  items: NavItem[];
  test: any;
  constructor(
    public authQuery: AuthQuery,
    private _drawerService: NzDrawerService,
    private _modalService: NzModalService,
    private translate: TranslateService
  ) {
    translate.setDefaultLang('vn');
  }
  switchLanguage(language: string){
    this.translate.use(language);
  }
  ngOnInit(): void {
  }

  openSettingDrawler() {
    this._drawerService.create({
      nzContent: SettingDrawerComponent,
      nzTitle: 'Cài đặt',
      nzPlacement: 'right',
      nzClosable: false,
      nzWidth: 700
    });
  }
  openSearchDrawler() {
    this._drawerService.create({
      nzContent: SearchDrawerComponent,
      nzTitle: null,
      nzPlacement: 'right',
      nzClosable: false,
      nzWidth: 500
    });
  }
  hiddenNav(){
    this.changeShowNav.emit(false);
  }
}

class NavItem {
  constructor(public icon: string, public tooltip: string, public handler: Handler) {}
}

interface Handler {
  (): void;
}
